import { Injectable } from '@angular/core';
import { TaskModel } from './model/task.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  constructor(private http: HttpClient) { }

  getTaskList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/task/get', requestData);
  }

  getTaskById(id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/task/get/' + id, '');
  }

  update(taskInfo: TaskModel): Observable<any> {
    if (taskInfo.hasOwnProperty("id")) {
      return this.http.post(environment.baseUrl + '/' + environment.app + '/task/update', taskInfo);
    } else {
      return this.http.post(environment.baseUrl + '/' + environment.app + '/task/add', taskInfo);
    }
  }

  delete(taskInfo: TaskModel): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/task/delete/' + taskInfo.id, taskInfo);
  }

  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(environment.baseUrl + '/' + environment.app + '/task/export-task-list', requestData, { headers, responseType: 'blob' });
  }

}
